'use client';
import Typography from '@/components/shared/typography/typography.component';
import { colors } from '@/constants';
import myImageLoader from '@/image.local.loader';
import { useTranslation } from 'react-i18next';

const RadioBoxSimple = ({
    text,
    value,
    selected,
    radioBoxClicked,
    variant,
    icon = undefined,
    description = undefined,
    isNew = false,
}: {
    text: string;
    value: string;
    selected: boolean;
    icon?: any;
    description?: string;
    radioBoxClicked: (text: string) => void;
    variant?: 'row' | 'row-reverse';
    isNew?: boolean;
}) => {
    const { t } = useTranslation();
    return (
        <div
            onClick={() => radioBoxClicked(value)}
            className={`
                w-full px-3 py-2 rounded-lg gap-3 flex items-center cursor-pointer
                border transition-colors
                ${
                    selected
                        ? 'border-green-600 bg-green-50'
                        : 'border-gray-200 bg-white'
                }
            `}
            style={{
                flexDirection: variant,
                borderColor: selected
                    ? colors['green-600']
                    : colors['gray-200'],
                backgroundColor: selected ? colors['green-50'] : 'white',
            }}
        >
            <div
                className={`
                    w-4 h-4 rounded-full flex items-center justify-center
                    border transition-colors shrink-0
                    ${
                        selected
                            ? 'border-green-600 bg-green-50'
                            : 'border-gray-200 bg-white'
                    }
                `}
                style={{
                    borderColor: selected
                        ? colors['green-600']
                        : colors['gray-200'],
                    backgroundColor: selected ? colors['green-50'] : 'white',
                }}
            >
                <div
                    className={`
                        w-1.5 h-1.5 rounded-full transition-colors
                        ${selected ? 'bg-green-600' : 'bg-white'}
                    `}
                    style={{
                        backgroundColor: selected
                            ? colors['green-600']
                            : 'white',
                    }}
                />
            </div>
            <div className="flex flex-col gap-0.5 flex-1">
                <div className="flex justify-between items-center">
                    <div className="flex gap-0.5 items-center">
                        <Typography
                            variant="body2Medium"
                            className="text-gray-700"
                        >
                            {text}
                        </Typography>
                        {icon && (
                            <img
                                src={myImageLoader({
                                    src: icon.src,
                                    width: 28,
                                    height: 28,
                                })}
                                alt={`Sylndr ${text}`}
                                width={24}
                                height={24}
                            />
                        )}
                    </div>
                    {isNew && (
                        <div className="bg-error-600 rounded-md px-1 py-0.5">
                            <Typography
                                className="text-caption2Medium text-white text-center en:pt-0.5"
                                style={{ lineHeight: 'normal' }}
                            >
                                {t('NewFilter')}
                            </Typography>
                        </div>
                    )}
                </div>
                {description && (
                    <Typography
                        variant="captionMedium"
                        className="text-gray-500"
                    >
                        {description}
                    </Typography>
                )}
            </div>
        </div>
    );
};

export default RadioBoxSimple;
